var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProteinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 6,
    fill: "#4AB8FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2353 24.4706C38.8824 24.1176 38.4118 23.8823 38.0588 23.8823C37.9412 23.4118 37.8235 23.0588 37.4706 22.7059C36.6471 21.8823 35.2353 21.8823 34.4118 22.7059C33.7059 23.4118 33.5882 24.5882 34.1765 25.4118L31.5882 27.8823L30.2941 26.5882L27.7059 29.1765C27.4706 29.0588 27.1176 29.0588 26.8824 29.0588C23.5882 29.0588 21 31.647 21 34.9412C21 38.2353 23.5882 40.8235 26.8824 40.8235C30.1765 40.8235 32.7647 38.2353 32.7647 34.9412C32.7647 34.7059 32.7647 34.3529 32.6471 34.1176L35.2353 31.5294L33.9412 30.2353L36.4118 27.7647C37.2353 28.3529 38.4118 28.2353 39.1176 27.5294C40.0588 26.7059 40.0588 25.2941 39.2353 24.4706Z",
    fill: "#4AB8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinIcon);
export default __webpack_public_path__ + "static/media/protein-icon.c285979616f56dc9dfa457e51c583d68.svg";
export { ForwardRef as ReactComponent };